// extracted by mini-css-extract-plugin
export default {"container":"class_container__ULMo6","loading":"class_loading__kUil6"};